import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { useEffect, useRef, useState } from 'react';

const IframeTestPage = () => {
    const [showDialog, setShowDialog] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    const IFRAME_URL = 'https://fleetassistant-staging.rio.cloud/';
    const SOURCE_APP = 'fleet-assistant';

    const handleOpenInNewWindow = () => {
        window.open(`${IFRAME_URL}?ref=${SOURCE_APP}`, '_blank');
    };

    useEffect(() => {
        if (showDialog) {
            const timer = setTimeout(() => {
                if (iframeRef.current && iframeRef.current.contentWindow) {
                    iframeRef.current.contentWindow.postMessage(
                        { sourceApp: SOURCE_APP },
                        IFRAME_URL
                    );
                }
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [showDialog]);

    const body = (
        <div className="iframe-wrapper">
            <iframe
                ref={iframeRef}
                title="fullscreen dialog"
                className="unstyled bg-lighter full-window no-application-header"
                src={IFRAME_URL}
            />
        </div>
    );

    const headerButtons = (
        <OverlayTrigger placement="bottom" overlay={<Tooltip width="auto">Open in new window</Tooltip>}>
            <Button bsStyle="muted" iconOnly onClick={handleOpenInNewWindow} data-testid="open-in-new-window-button">
                <span className="rioglyph rioglyph-new-window" />
            </Button>
        </OverlayTrigger>
    );

    const testIntegration = (
        <>
            <p className="margin-bottom-10 text-16 max-width-50pct text-center margin-bottom-20">
                This is a test route to evaluate how the application performs when integrated in an iframe. Use the
                button below
                to open the application in fullscreen mode within an iframe.
            </p>

            <Button onClick={() => setShowDialog(true)}>
                <span>Open Fleet Assistant in fullscreen dialog</span>
            </Button>

            <Dialog
                show={showDialog}
                title="Fleet Assistant"
                bodyClassName="padding-0"
                body={body}
                onClose={() => setShowDialog(false)}
                showCloseButton
                bsSize={Dialog.SIZE_FULL_SCREEN}
                headerButtons={headerButtons}
            />
        </>
    );


    const codeIframeRef = `
    const IFRAME_URL = 'https://fleetassistant.rio.cloud/';
    const SOURCE_APP = 'YOUR APP';
    
        <iframe ref={iframeRef}
               title="fullscreen dialog"
               className="unstyled bg-lighter full-window no-application-header"
         />
    
    iframeRef.current.contentWindow.postMessage({ sourceApp: SOURCE_APP },IFRAME_URL);`;

    return (
        <>
            <div className="row">
                <div className="col-6 margin-bottom-20 padding-20 height-75vh display-flex flex-column justify-content-center align-items-center ">
                    {testIntegration}
                </div>
                <div
                    className="col-6 margin-bottom-20 padding-20 height-75vh display-flex flex-column justify-content-center align-items-center ">
                    <pre><code>{codeIframeRef}</code></pre>
                </div>
            </div>
        </>
    );
};

export default IframeTestPage;
